import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3375c5dc"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3375c5dc')) {
      api.createRecord('3375c5dc', component.options)
    } else {
      api.reload('3375c5dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3375c5dc", function () {
      api.rerender('3375c5dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/border/index.vue"
export default component.exports